//
import { CookieBanner } from "components/cookie-banner";
import Container from "components/styled/container";
import Header from "containers/header";
//
import Meta from "containers/meta";
import React from "react";
import { Root } from "react-static";
import styled from "styled-components";
import { Provider } from "unstated";
//
//
export default ({ children }) => (
	<CookieBanner>
		<Provider>
			<Root>
				<Meta />
				<Wrap>
					<Header />
					<Inner>{children}</Inner>
				</Wrap>
			</Root>
		</Provider>
	</CookieBanner>
);
//
const Wrap = styled(Container)``;
const Inner = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    padding-left: 200px;
  }
`;
